import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navigation_drawer = _resolveComponent("navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      (_ctx.isReady)
        ? (_openBlock(), _createBlock(_component_navigation_drawer, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (_ctx.isReady)
            ? (_openBlock(), _createBlock(_component_v_container, {
                key: 0,
                fluid: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_overlay, {
                key: 1,
                value: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    size: "64"
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}